<template>
  <div @click="hideLanguageList()" class="login fs-14 c-152338">
    <div v-loading="isLoadingLogin" class="loginContent">
      <div class="hintText">
        <div>借助最新的<span class="fw-b">AI技术</span>，</div>
        <div>以温暖、体贴的方式与<span class="fw-b">用户交互</span>，</div>
        <div>理解人类的<span class="fw-b">情感需求</span>。</div>
      </div>
      <div class="circularDiv">
        <div></div>
      </div>
      <img src="../../assets/login/bg.png" class="bg" />
      <div class="circular2Div"></div>
      <div class="circular3Div">
        <div></div>
      </div>

      <div class="loginLayout">
        <div class="title c-0054fe"><span class="fw-b">星云</span> 心理健康运营平台</div>
        <div class="mt-45">
          <div class="labelItem">
            <input @keydown="onKeydown($event)" maxlength="50" v-model="model.userName" autocomplete="username"
              :placeholder="$t('login.accountHint')" />
            <img src="../../assets/login/icon_account_login.png" class="icon" />
          </div>
        </div>
        <div class="mt-20">
          <div class="labelItem">
            <input @keydown="onKeydown($event)" maxlength="15" v-model="model.passWord" type="password"
              autocomplete="current-password" :placeholder="$t('login.passwordHint')" />
            <img src="../../assets/login/icon_password.png" class="icon" />
          </div>
        </div>
        <div @click="onClickLogin()" class="loginBtn">{{$t("login.login")}}</div>
      </div>
    </div>
    <!-- 背景 -->
    <div v-if="false" class="bgLayout">
      <!-- 国际化 -->
      <!-- <div @click.stop="showLanguageList()" class="language">
        <div class="flex-grow-1 mr-5">{{selectLanguage.name}}</div>
        <img width="15" height="10.5" src="../../assets/login/icon-Triangle-login.svg" />
        <div v-show="isShowLanguageList" class="languageList">
          <div @click.stop="onClickCutLanguage(item)" :class="{'isSelect':selectLanguage.key==item.key}" class="item"
            v-for="item in languageList">{{item.name}}</div>
        </div>
      </div> -->
      <!-- 内容 -->
      <div class="content">
        <div class="cut">
          <!-- <div @click="onClickCut(0)" :select="cutType===0">
            <div>{{$t("login.telLogin")}}
              <div class="line"></div>
            </div>
          </div> -->
          <div @click="onClickCut(1)" :select="cutType===1">
            <div>{{$t("common.appName")}}
              <div class="line"></div>
            </div>
          </div>
        </div>
        <!-- 手机登录 -->
        <div v-show="cutType===0" class="telLayout">
          <div class="label">
            <img class="mr-13" width="16" height="25.6" src="../../assets/login/icon_phone.svg" />
            <input @keydown="onKeydown($event)" @input="editTel" v-model="model.telephone"
              :placeholder="$t('login.telHint')" />
          </div>
          <div class="display-flex mt-15">
            <div class="label codeInputLayout">
              <img class="mr-13" width="18" height="20.57142857142857" src="../../assets/login/icon_shield.svg" />
              <input @keydown="onKeydown($event)" v-model="model.telLoginCode" :placeholder="$t('login.telCode')" />
            </div>
            <div v-loading="isLoadingSendCode" @click="onClickSendCode()" class="sendCode click">
              {{countDown===0?$t('login.sendCode'):(countDown+'s')}}
            </div>
          </div>
        </div>
        <!-- 账号登录 -->
        <form>
          <div v-show="cutType===1" class="accountLayout">
            <div class="label">
              <img class="mr-13" width="18" height="19.2" src="../../assets/login/icon_account_login.svg" />
              <input @keydown="onKeydown($event)" maxlength="50" v-model="model.userName" autocomplete="username"
                :placeholder="$t('login.accountHint')" />
            </div>
            <div class="label mt-15">
              <img class="mr-13" width="18" height="22.15384615384616" src="../../assets/login/icon_password.svg" />
              <input @keydown="onKeydown($event)" maxlength="15" v-model="model.passWord" type="password"
                autocomplete="current-password" :placeholder="$t('login.passwordHint')" />
            </div>
            <!-- 验证码 -->
            <div v-if="isEditCode" class="display-flex mt-15">
              <div class="label codeInputLayout">
                <img class="mr-13" width="18" height="20.57142857142857" src="../../assets/login/icon_shield.svg" />
                <input @keydown="onKeydown($event)" v-model="model.code" :placeholder="$t('login.code')" />
              </div>
              <div class="label codeLayout">
                <div class="codePic flex-grow-1">
                  <img :src="codePic" />
                </div>
                <div @click="interfaceId++;getCodePic(interfaceId)" class="refresh click">
                  <img width="19.2" height="16.8" src="../../assets/login/icon_refresh_login.svg" />
                </div>
              </div>
            </div>
          </div>
        </form>
        <div :class="{'pe-none':isLoadingLogin,'mt-30':isEditCode&&cutType===1}" @click="onClickLogin()"
          class="loginbtn commonbtn btn-2d95f0">{{$t('login.login')}}</div>
      </div>
    </div>
    <div v-if="false" class="info2">
      <span>CopyRight©2019</span>
      <span>{{$t('common.corporate2')}}</span>
      <span @click="onClickBeian()" class="click">ICP证：粤ICP备2024170879号</span>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import '@/style/login/login.scss';
  import i18next from 'i18next';

  export default {
    name: 'login',
    data() {
      return {
        intervalId: null, //定时器
        cutType: 1, //0 手机登录 1账号密码登录
        selectLanguage: {
          key: "zh-CN",
          name: "中文简体"
        },
        model: {
          userName: "", //账号
          passWord: "", //密码

          code: "", //验证码
          area: "1", //区号
          telephone: "", //手机号
          telLoginCode: "" //手机验证码
        },
        isEditCode: false, //判断是否需要输入验证码
        codePic: "", //验证码图片
        interfaceId: 0,
        isLoadingLogin: false, //判断是否正在调用登录接口
        isLoadingSendCode: false, //判断是否正在调用发送验证码接口
        languageList: [], //国际化列表
        isShowLanguageList: false, //是否显示国际化列表
        isRunInterface: false,
        countDown: 0 //倒计时
      }
    },
    created() {
      this.mergeLang("login");
      this.initLanguage();
      // 检测是否已经登录
      // if (this.$utils.isLogin()) {
      //   this.$router.push({
      //     name: 'tab'
      //   });
      // }
    },
    mounted() {
      if (this.$route.query.loginTimeOut == "1") {
        this.$toast.showToast(this.$t("interfaceToast.loginTimeout"), "warning");
      }
    },
    destroyed() { //组件销毁
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
    methods: {
      /**
       *  设置语言
       */
      initLanguage() {
        this.languageList = this.$utils.getLanguageList();
        let language = localStorage.getItem("language");
        if (language) {
          for (let i = 0; i < this.languageList.length; i++) {
            if (this.languageList[i].key == language) {
              this.selectLanguage = this.languageList[i];
              break;
            }
          }
        } else {
          this.selectLanguage = this.languageList[0];
        }
      },
      onClickBeian() {
        window.open("http://beian.miit.gov.cn", "_blank");
      },
      /**
       * 显示国际化列表
       */
      showLanguageList() {
        this.isShowLanguageList = !this.isShowLanguageList;
      },
      /**
       * 隐藏国际化列表
       */
      hideLanguageList() {
        this.isShowLanguageList = false;
      },
      /**
       * 切换语言
       * @param {Object} item 语言类型实体
       */
      onClickCutLanguage(item) {
        this.$i18n.locale = item.key;
        i18next.changeLanguage(item.key);
        this.selectLanguage = item;
        localStorage.setItem("language", item.key);
        this.isShowLanguageList = false;
      },
      /**
       * 切换登录方式
       * @param {Object} type
       */
      onClickCut(type) {
        if (this.cutType == type) return;
        this.cutType = type;
      },
      /**
       * 监听手机号输入（限制只能输入数字）
       */
      editTel() {
        this.model.telephone = this.model.telephone.replace(/\D+/g, '');
      },
      /**
       * 发送验证码
       */
      onClickSendCode() {
        if (this.model.telephone == "") {
          this.$toast.showToast(this.$t('login.telHint'), "warning");
          return;
        }
        let that = this;
        let params = {
          url: this.$request.url.login.sendCode,
          data: {
            mobile: this.model.telephone
          },
        }
        this.isLoadingSendCode = true;
        this.$request.get(params, function(type, response) {
          that.isLoadingSendCode = false;
          if (type == 0) {
            that.startCountDown();
          }
        });
      },
      /**
       * 倒计时
       */
      startCountDown() {
        if (this.countDown == 0) {
          this.countDown = 60;
          let that = this;
          this.intervalId = setInterval(function() {
            that.countDown--;
            if (that.countDown == 0) {
              clearInterval(that.intervalId);
            }
          }, 500);
        }
      },
      /**
       * 监听键盘按键
       * @param {Object} event
       */
      onKeydown(event) {
        if (event.keyCode == 13) {
          this.onClickLogin();
        }
      },
      /**
       * 登录
       */
      onClickLogin() {
        // this.$router.push({
        //   name: 'tab'
        // });
        // return;
        let $utils = this.$utils;
        if (this.cutType == 0) {
          if (this.model.telephone == "") {
            this.$toast.showToast(this.$t('login.telHint'), "warning");
            return;
          }
          if (this.model.telLoginCode.trim() == "") {
            this.$toast.showToast(this.$t('login.telCodeHint'), "warning");
            return;
          }
          this.mobileLogin();
        } else {
          if (this.model.userName.trim() == "") {
            this.$toast.showToast(this.$t('login.accountHint'), "warning");
            return;
          }
          if (this.model.passWord == "") {
            this.$toast.showToast(this.$t('login.passwordToastHint'), "warning");
            return;
          }
          if (this.isEditCode && this.model.code.trim() == "") {
            this.$toast.showToast(this.$t('login.codeHint'), "warning");
            return;
          }
          this.passWordLogin();
        }
      },
      /**
       * 账号密码登录
       */
      passWordLogin() {
        let params = {
          url: this.$request.url.login.login,
          data: {
            username: this.model.userName,
            password: this.model.passWord
          }
        }
        this.isLoadingLogin = true;
        this.$request.post(params, (type, response) => {
          if (type == 0) {
            const data = response.data;
            const userInfo = data.sysUser;
            const token = data.token;
            userInfo.token = token;
            this.getRoutersMenu(userInfo);
          } else {
            this.isLoadingLogin = false;
          }
        });
      },
      /**
       * 判断是否需要获取验证码
       */
      captchaNeed() {
        let that = this;
        let params = {
          url: this.$request.url.login.captchaNeed,
          data: {}
        }
        this.isLoadingLogin = true;
        this.$request.get(params, function(type, response) {
          if (type == 0) {
            if (response.data) { //需要显示验证码
              that.isEditCode = true;
              that.interfaceId++;
              that.getCodePic(that.interfaceId);
            } else {
              that.passWordLogin();
            }
          } else {
            that.isLoadingLogin = false;
          }
        });
      },
      /**
       * 手机号登录
       */
      mobileLogin() {
        let that = this;
        let params = {
          url: this.$request.url.login.mobileLogin,
          data: {
            mobile: this.model.telephone,
            smsCode: this.model.telLoginCode
          }
        }
        this.isLoadingLogin = true;
        this.$request.postForm(params, function(type, response) {
          if (type == 0) {
            response.data.userId = response.data.user_info.id;
            that.getDictionary(response.data);
          } else {
            that.isLoadingLogin = false;
          }
        });
      },
      /**
       * 获取验证码图片
       */
      getCodePic(interfaceId) {
        let that = this;
        let params = {
          url: this.$request.url.login.codePic,
          data: {},
        }
        this.isLoadingLogin = true;
        this.$request.get(params, function(type, response) {
          if (that.interfaceId != interfaceId) return;
          that.isLoadingLogin = false;
          if (type == 0) {
            that.codePic = response.data;
          }
        });
      },
      // 获取按钮列表
      getRoutersMenu(userInfo) {
        let params = {
          url: this.$request.url.login.getRoutersMenu,
          headers: {
            tenantId: userInfo.tenantId,
            Authorization: "Bearer " + userInfo.token
          }
        }
        this.isLoadingLogin = true;
        this.$request.get(params, (type, response) => {
          if (type == 0) {
            const buttonPermissionList = response.data || [];
            this.getMenuRounters(userInfo, buttonPermissionList);
          } else {
            this.isLoadingLogin = false;
          }
        });
      },
      getMenuRounters(userInfo, buttonPermissionList) {
        let params = {
          url: this.$request.url.login.getMenuRounters,
          headers: {
            tenantId: userInfo.tenantId,
            Authorization: "Bearer " + userInfo.token
          }
        }
        this.isLoadingLogin = true;
        this.$request.get(params, (type, response) => {
          if (type == 0) {
            const menuList = response.data || [];
            const tabMenuList = [];
            menuList.forEach((menuItem) => {
              if (menuItem.meta && menuItem.children && menuItem.children.length > 0) {
                const children = [];
                tabMenuList.push({
                  name: menuItem.meta.title,
                  path: "",
                  code: menuItem.component,
                  icon: menuItem.meta.icon,
                  type: "menu",
                  children: children
                });
                menuItem.children.forEach((item) => {
                  children.push({
                    name: item.meta.title,
                    path: item.path,
                    code: item.component,
                    type: "page"
                  })
                })
              } else if (!menuItem.meta && menuItem.children && menuItem.children.length > 0) {
                tabMenuList.push({
                  name: menuItem.children[0].meta.title,
                  path: menuItem.children[0].path,
                  code: menuItem.children[0].component,
                  icon: menuItem.children[0].meta.icon,
                  type: "page"
                })
              }
            });
            // 保存按钮权限信息
            this.$utils.saveButtonPermission(buttonPermissionList);
            // 保存菜单权限信息
            this.$utils.saveMenuList(tabMenuList);
            // 保存用户信息
            this.$utils.setUserInfo(userInfo);
            localStorage.setItem("isFristLogin", '1');
            window.location.replace("/");
          } else {
            this.isLoadingLogin = false;
          }
        });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/login/login.vue